import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * Unwraps the Java backend's ResponseDTO envelope.
 *
 * Java API returns: { status: number, message: string, data: T }
 * Frontend expects: T
 *
 * Only applies to responses from apiBaseUrl.  Responses that don't
 * match the ResponseDTO shape are passed through unchanged.
 */

function isResponseDTO(body: any): body is { status: number; message: string; data: unknown } {
  return (
    body !== null &&
    typeof body === 'object' &&
    typeof body.status === 'number' &&
    typeof body.message === 'string' &&
    'data' in body
  );
}

export const responseUnwrapInterceptor: HttpInterceptorFn = (req, next) => {
  const apiBase = environment.apiBaseUrl;
  if (!req.url.startsWith(apiBase)) return next(req);

  return next(req).pipe(
    map(event => {
      if (event instanceof HttpResponse && isResponseDTO(event.body)) {
        return event.clone({ body: event.body.data });
      }
      return event;
    }),
  );
};
